import React from 'react';
import withIcon from '../utilities/withIcon';

const IconParagraph = () => {
  return (
    <g>
      <path d="m14.0029.1411h-8.3955a4.36 4.36 0 0 0 0 8.7207h1.439v6.2471a.75.75 0 0 0 1.5 0v-13.4678h2.1685v13.4678a.75.75 0 0 0 1.5 0v-13.4678h1.7881a.75.75 0 1 0 0-1.5zm-6.9565 7.2207h-1.439a2.86 2.86 0 1 1 0-5.7207h1.439z" />
    </g>
  );
};

export default withIcon(IconParagraph);
